// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src\\pages\\dashboard\\Dashboard.css */


.dashboard-modal .modal-content {
    /* Custom styles for the dashboard modal */
    width: 50%; /* Example: Set the width to 50% of the screen size */
    min-height: 300px; /* Example: Set a minimum height */
    /* Add more customizations as needed */
  }

  .cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); /* Change this to 'auto-fit' and adjust minmax as needed */
    gap: 1rem; /* This can be adjusted to control the space between cards */
    margin: 1rem;
    align-items: start; /* Aligns the cards at the top */
  }
  
  .card {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
    padding: 20px;
    margin: 10px; /* Adjust margin for space between cards */
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centers content vertically if you don't have much content */
    min-height: 200px; /* Set a minimum height for your cards */
    margin-top: 0;
  }
  
  .dashboard-banner {
    background-color: #4991c9; /* Example background color, you can choose any */
    border-radius: 10px; /* Rounded corners */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Shadow to match the cards */
    padding: 20px; /* Inner spacing */
    margin: 1rem 10px; /* Space above and on the sides of the banner */
    transition: transform 0.3s ease-in-out; /* Smooth transition for hover effect */
  }
  
  .dashboard-banner:hover {
    transform: translateY(-5px); /* Raise effect on hover */
  }

  @media only screen and (max-width: 768px) {
    .cards-container {
      grid-template-columns: 1fr; /* Full width cards on smaller screens */
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA,sCAAsC;;;AAGtC;IACI,0CAA0C;IAC1C,UAAU,EAAE,qDAAqD;IACjE,iBAAiB,EAAE,kCAAkC;IACrD,sCAAsC;EACxC;;EAEA;IACE,aAAa;IACb,2DAA2D,EAAE,0DAA0D;IACvH,SAAS,EAAE,4DAA4D;IACvE,YAAY;IACZ,kBAAkB,EAAE,gCAAgC;EACtD;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,YAAY,EAAE,0CAA0C;IACxD,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,8DAA8D;IACvF,iBAAiB,EAAE,wCAAwC;IAC3D,aAAa;EACf;;EAEA;IACE,yBAAyB,EAAE,iDAAiD;IAC5E,mBAAmB,EAAE,oBAAoB;IACzC,wCAAwC,EAAE,8BAA8B;IACxE,aAAa,EAAE,kBAAkB;IACjC,iBAAiB,EAAE,+CAA+C;IAClE,sCAAsC,EAAE,uCAAuC;EACjF;;EAEA;IACE,2BAA2B,EAAE,0BAA0B;EACzD;;EAEA;IACE;MACE,0BAA0B,EAAE,wCAAwC;IACtE;EACF","sourcesContent":["/* src\\pages\\dashboard\\Dashboard.css */\n\n\n.dashboard-modal .modal-content {\n    /* Custom styles for the dashboard modal */\n    width: 50%; /* Example: Set the width to 50% of the screen size */\n    min-height: 300px; /* Example: Set a minimum height */\n    /* Add more customizations as needed */\n  }\n\n  .cards-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); /* Change this to 'auto-fit' and adjust minmax as needed */\n    gap: 1rem; /* This can be adjusted to control the space between cards */\n    margin: 1rem;\n    align-items: start; /* Aligns the cards at the top */\n  }\n  \n  .card {\n    background: #ffffff;\n    border-radius: 10px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);\n    padding: 20px;\n    margin: 10px; /* Adjust margin for space between cards */\n    display: flex;\n    flex-direction: column;\n    justify-content: center; /* Centers content vertically if you don't have much content */\n    min-height: 200px; /* Set a minimum height for your cards */\n    margin-top: 0;\n  }\n  \n  .dashboard-banner {\n    background-color: #4991c9; /* Example background color, you can choose any */\n    border-radius: 10px; /* Rounded corners */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Shadow to match the cards */\n    padding: 20px; /* Inner spacing */\n    margin: 1rem 10px; /* Space above and on the sides of the banner */\n    transition: transform 0.3s ease-in-out; /* Smooth transition for hover effect */\n  }\n  \n  .dashboard-banner:hover {\n    transform: translateY(-5px); /* Raise effect on hover */\n  }\n\n  @media only screen and (max-width: 768px) {\n    .cards-container {\n      grid-template-columns: 1fr; /* Full width cards on smaller screens */\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
